(() => {
  angular
    .module('complianceFrameworkApp', [
      /* Shared modules */
      'complianceFrameworkApp.core',

      /* Products */
      'complianceFrameworkApp.complianceFramework',
      'complianceFrameworkApp.complianceServices',
      'complianceFrameworkApp.complianceForums',
      'complianceFrameworkApp.socialMediaCompliance',
      'complianceFrameworkApp.tridCalculator',
      'complianceFrameworkApp.vms'
    ]);
})();
